import axios from 'axios';
const PUBLIC_ROOT = '/public';
export default {
	sendInterest(interest) {
		return axios.post(`${PUBLIC_ROOT}/properties/interest`, interest);
	}
};
